import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { history } from '../../../../store'
import { Button } from 'react-bootstrap'

import { CHANGE_SUBMISSION, SUBMISSION_STATUS } from '../../../../constants/submission'
import { CANCEL_IMPERSONATION } from '../../../../person/actions'
import { submissionCreate } from '../../../../submissions/actions'
import { getCurrentSession } from '../../../../../lib/authentication'
import { PRESIGN_BUCKET_LOOKUP_KEYS } from '../../../../../app/constants'

// Note: Ensure apigClient is imported or available in scope
export const ProductChoiceItem = ({
  features = [],
  name,
  subtitle,
  type,
  applicationForm
}) => {
  const dispatch = useDispatch()
  const downloadApplicationRef = useRef(null)

  const handleGenericS3PresignedURL = async (elementRef, bucketKey, fileName) => {
    try {
      const { accessToken } = await getCurrentSession()

      const response = await apigClient.presignedURLGenericGet(
        { bucketKey, fileName },
        {},
        { headers: { Authorization: accessToken } },
      )

      const url = response?.data?.url

      if (typeof url === 'string' && url.length > 0) {
        elementRef.current.href = url
        elementRef.current.click()
      }
    } catch (e) {
      console.error(e.message)
    }
  }

  const handleStartSubmission = () => {
    dispatch({
      type: CHANGE_SUBMISSION,
      payload: {
        submission: { type, status: SUBMISSION_STATUS.CLEARANCE }
      }
    })

    dispatch({ type: CANCEL_IMPERSONATION })

    dispatch(submissionCreate({ Type: type }))

    history.push('/clearance')
  }

  return (
    <div data-type={type}>
      <div className="productContainer">
        <div className="textContainer">
          <header>
            <h4>{name}</h4>
            <span>{subtitle}&nbsp;</span>
          </header>
          <div>
            {features.length > 0 && (
              <ul>
                {features.map((feature, i) => (
                  <li key={i}>{feature}</li>
                ))}
              </ul>
            )}
            <a
              className="s3-link"
              onClick={() =>
                handleGenericS3PresignedURL(
                  downloadApplicationRef,
                  PRESIGN_BUCKET_LOOKUP_KEYS.ASSETS_PDFS,
                  `${applicationForm.fileName}.pdf`
                )
              }
            >
              Download Application
            </a>
            <a
              className="s3-link-hidden"
              download={applicationForm.download}
              alt={applicationForm.alt}
              target="_blank"
              rel="noopener noreferrer"
              ref={downloadApplicationRef}
            />
            <Button
              onClick={handleStartSubmission}
              id="btn-start-submission"
            >
              Start Submission
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

ProductChoiceItem.propTypes = {
  broker: PropTypes.string,
  description: PropTypes.string,
  features: PropTypes.array,
  name: PropTypes.string,
  subtitle: PropTypes.string,
  type: PropTypes.string,
  applicationForm: PropTypes.object
}

export default ProductChoiceItem
